import React from 'react';
import { BodyTextBoldPrimary } from '@/shared/ui/typography';

import { Image } from '@/shared/ui/image';

import { Box } from '@/shared/ui/box';

export const BonusNotFound = ({ t }) => {
  return (
    <Box $display={'flex'} $justifyContent={'center'} $paddingTop={'90px'}>
      <Box $textAlign="center">
        <BodyTextBoldPrimary>{t('empty')}</BodyTextBoldPrimary>
        <Image
          alt="not found"
          src="/images/no-bonus-pic.png"
          width={240}
          height={220}
          margin={'auto'}
        />
      </Box>
    </Box>
  );
};
